module.exports = __webpack_public_path__ + "img/2021-radio-flamingo.b3eee46a.jpg";